

export class GetListBO {
    orderColumn: string = "name";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    agencyID: string;
    field: string = "name";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
}
export class SupportPlannerBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    agencyId: string;
    name: string;
    street: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
    fax: string;
    email: string;
    support_AgencyName:string;
}
export class WhereCondition {
    field: string = "name";
    value: string = "";
    operator: string = "startswith";
    orderNo: number = 1;
    predicate: string = "and";
    type: string = "string";
    matchCase: boolean = false;
}

export class functionpermission {
    supportplannercreate: boolean = true;
    supportplannerupdate: boolean = true;

}